import { Component, HostListener } from '@angular/core';
import { NavigationService } from '../../services/shared/navigation.service';

@Component({
    template: ''
})
export abstract class PageBaseComponent extends NavigationService {

    @HostListener('swipeleft')
    onSwipeLeft() {
        this.next();
    }

    @HostListener('swiperight')
    onSwipeRight() {
        this.back();
    }

    public abstract next(): void;
    public abstract back(): void;
}